export default "__VITE_ASSET__DD$OftX5__"